// Routes.js
import React from 'react';
import {Routes as ReactRoutes, Route} from 'react-router-dom'
import {GiftCardForm, GiftCardDetail, GiftCardBalance, BulkOrderView} from "./pages";

function Routes(props) {

  const {location} = props;

  return (
    <ReactRoutes>
      <Route exact path="/a/gc/gift-card/"
        element={
          <GiftCardForm
          preview={false}
          setEmailPreviewData={() => {}} // Hack to ensure this doesn't break.
          />
        }
      />

      <Route  exact path="/a/gc/gift-card/balance/"
        element={<GiftCardBalance />}
      />

      <Route exact path="/a/gc/gift-card/:token/"
        element={<GiftCardDetail previewSettings={{}} preview={false} />}
      />

      <Route exact path="/a/gc/gift-card/:type/purchase"
        element={
          <GiftCardForm
          preview={false}
          setEmailPreviewData={() => {}} // Hack to ensure this doesn't break.
          />
        }
      />

      <Route  exact path="/a/gc/gift-card/:type/bulk-order/"
        element={
          <GiftCardForm
          preview={false}
          setEmailPreviewData={() => {}} // Hack to ensure this doesn't break.
          bulkOrder={true}
          />
        }
      />

      <Route exact path="/:lang/a/gc/gift-card/"
        element={
          <GiftCardForm
          preview={false}
          setEmailPreviewData={() => {}} // Hack to ensure this doesn't break.
          />
        }
      />

      <Route exact path="/:lang/a/gc/gift-card/:type/purchase"
        element={
          <GiftCardForm
          preview={false}
          setEmailPreviewData={() => {}} // Hack to ensure this doesn't break.
          />
        }
      />

      <Route exact path="/:lang/a/gc/gift-card/:type/bulk-order/"
        element={
          <GiftCardForm
          preview={false}
          setEmailPreviewData={() => {}} // Hack to ensure this doesn't break.
          bulkOrder={true}
          />
        }
      />

      <Route  exact path="/:lang/a/gc/gift-card/balance/"
        element={<GiftCardBalance />}
      />

      <Route  exact path="/:lang/a/gc/gift-card/:token/"
        element={<GiftCardDetail previewSettings={{}} preview={false} />}
      />
    </ReactRoutes>
  );
}

export default Routes;
